import { toast } from "react-toastify";

export const notifySuccess = (message, options = {}) =>
  toast.success(message, { ...options });

export const notifyError = (message, options = {}) =>
  toast.error(message, { ...options });

export const notifyInfo = (message, options = {}) =>
  toast.info(message, { ...options });

export const notifyWarning = (message, options = {}) =>
  toast.warning(message, { ...options });

export const dismissToast = (toastId) => toast.dismiss(toastId);

export const rawToast = toast;
